import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\OtaNoShowController::retry
* @see app/Http/Controllers/Admin/Bookings/OtaNoShowController.php:17
* @route '/bookings/{booking}/ota-no-show/retry'
*/
export const retry = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/ota-no-show/retry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\OtaNoShowController::retry
* @see app/Http/Controllers/Admin/Bookings/OtaNoShowController.php:17
* @route '/bookings/{booking}/ota-no-show/retry'
*/
retry.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return retry.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\OtaNoShowController::retry
* @see app/Http/Controllers/Admin/Bookings/OtaNoShowController.php:17
* @route '/bookings/{booking}/ota-no-show/retry'
*/
retry.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\OtaNoShowController::retry
* @see app/Http/Controllers/Admin/Bookings/OtaNoShowController.php:17
* @route '/bookings/{booking}/ota-no-show/retry'
*/
const retryForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\OtaNoShowController::retry
* @see app/Http/Controllers/Admin/Bookings/OtaNoShowController.php:17
* @route '/bookings/{booking}/ota-no-show/retry'
*/
retryForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

retry.form = retryForm

const otaNoShow = {
    retry: Object.assign(retry, retry),
}

export default otaNoShow